import React, { useState } from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { Icon } from '../../components';
import './Style.scss';

const GLOSSARY_ENTRIES = [
  [
    { abbr: 'A.T', def: 'Atraso' },
    { abbr: 'CT', def: 'Cambio de Turno' },
    { abbr: 'JO', def: 'Jornada Ordinaria' },
    { abbr: 'POSTN', def: 'Postnatal' },
    { abbr: 'SMC', def: 'Sin Marca Colacion' },
    { color: '#F89406', def: 'Marcación Fuera de Turno' },
    { color: '#ff0000', def: 'Sin Registro de Marca' }
  ],
  [
    { abbr: 'AT.C', def: 'Atraso Colacion' },
    { abbr: 'DEJ', def: 'Distribución Excepcional de Jornada' },
    { abbr: 'LM', def: 'Licencia Médica' },
    { abbr: 'PREN', def: 'Prenatal' },
    { abbr: 'SMJ', def: 'Sin Marca Jornada' },
    { color: '#b4c7e7', def: 'Marca Modificada' },
    { icon: 'document-attach', def: 'Pacto de Horas Extras' }
  ],
  [
    { abbr: 'A.I', def: 'Ausencia Injustificada' },
    { abbr: 'ETC', def: 'Exceso Tiempo Colación' },
    { abbr: 'PGR', def: 'Permiso con Goce Remuneraciones' },
    { abbr: 'SA', def: 'Salida Anticipada' },
    { abbr: 'T.C.B.D.D.A', def: ' Trabajadores del Comercio Beneficiarios de Descansos Dominical' },
    { color: '#a9d18e', def: 'Marca Completada' }
  ],
  [
    { abbr: 'AJ', def: 'Ausencia Justificada' },
    { abbr: 'HE', def: 'Hora Extraordinaria' },
    { abbr: 'PSGR', def: 'Permiso Sin Goce Remuneraciones' },
    { abbr: 'SAC', def: 'Salida Anticipada Colación' },
    { abbr: 'VAC', def: 'Vacaciones' },
    { color: '#FFA07A', def: 'Sin Turno Asignado' }
  ]
];

const AbbreviationsGlossary = () => {
  const [activeKey, setActiveKey] = useState('0');

  return (
    <Accordion activeKey={activeKey} onSelect={k => setActiveKey(k || '')} className=" mt-1 mb-1">
      <Col className="top-header-green br-5 ">
        <Accordion.Toggle
          as={Col}
          eventKey="0"
          className="card-header-title arial-dt d-flex justify-content-between align-items-center "
        >
          <span>Glosario de Abreviaciones</span>
          <span className="font-weight-bold mb-0 font-size-1">{activeKey === '0' ? '−' : '+'}</span>
        </Accordion.Toggle>
      </Col>

      <Accordion.Collapse eventKey="0" className="glossary-accordion__body">
        <Card.Body className="glossary-accordion-table arial-dt arial-dt p-0">
          <Row className="no-gutters">
            {GLOSSARY_ENTRIES.map((column, colIndex) => (
              <Col key={`col-${column[0]?.abbr || column[0]?.def || colIndex}`} md={3}>
                {column.map(entry => (
                  <div
                    key={`${entry.def}-${entry.abbr || entry.color || entry.icon || ''}`}
                    className="glossary-row d-flex align-items-center"
                  >
                    <div className="glossary-cell glossary-abbr">
                      {entry.abbr && <span>{entry.abbr}</span>}
                      {entry.color && (
                        <span
                          className="glossary-color-swatch"
                          style={{ backgroundColor: entry.color }}
                          title={entry.def}
                        />
                      )}
                      {entry.icon && <Icon icon={entry.icon} width={14} height={14} />}
                    </div>
                    <div className="glossary-cell flex-grow-1">{entry.def}</div>
                  </div>
                ))}
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Accordion>
  );
};

export default AbbreviationsGlossary;
